import React, { Component } from 'react';
import {
  withStyles, CssBaseline,
} from '@material-ui/core';

import styles from '../assets/styles/jss/Home';
import Stepper from '../components/Stepper';

class Home extends Component {
  render() {
    return (
      <div>
        <CssBaseline />
        <Stepper />
      </div>
    );
  }
}

export default (withStyles(styles)(Home));
